import {cn} from '@/lib/utils'
import {type HTMLAttributes} from 'react'

// For headings and navigation using Roc Grotesk
export const Display = ({className, ...props}: HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className={cn('font-roc-grotesk text-4xl text-[#054A59]', className)} {...props} />
)

// For navigation items and buttons using Roc Grotesk
export const Label = ({className, ...props}: HTMLAttributes<HTMLSpanElement>) => (
  <h2 className={cn('font-roc-grotesk text-2xl', className)} {...props} />
)

// For body text using Inter
export const Text = ({className, ...props}: HTMLAttributes<HTMLParagraphElement>) => <p className={cn('font-inter text-lg', className)} {...props} />
